import React, { useState } from 'react'

import legends from './legends.json'
import Toggle from './Toggle'

import './Legend.sass'

export default function Legend ({ name }) {
  const legend = legends[name]
  const [visible, setVisible] = useState(true)

  return (
    <div className='legend' >
      <div className='legend-title'>
        <Toggle visible={visible} onClick={setVisible} />
        {legend.title}
      </div>
      {visible && legend.classes.map((item, i) => (
        <React.Fragment key={i}>
          <div className='colour-block' style={{ backgroundColor: `${item.colour}` }}>&nbsp;</div>
          <label>{item.name}</label>
        </React.Fragment>
      ))}
    </div>
  )
}
